// src/app/pages/CheckoutPage/CheckoutSkeleton.tsx
import { CardSkeleton } from "@/app/core/ui/skeletons/CardSkeleton";

export function OrderSummarySkeleton() {
  return (
    <CardSkeleton height="h-auto" animate={false} className="mb-6">
      <div className="space-y-3">
        <div className="h-3.5 w-24 animate-pulse rounded bg-muted" />
        <div className="h-5 w-48 animate-pulse rounded bg-muted" />
        <div className="h-8 w-32 animate-pulse rounded bg-muted" />
      </div>
    </CardSkeleton>
  );
}

export function TotalSectionSkeleton() {
  return (
    <CardSkeleton height="h-auto" animate={false} className="mb-6">
      <div className="space-y-3">
        <div className="h-3.5 w-16 animate-pulse rounded bg-muted" />
        <div className="flex justify-between">
          <div className="h-4 w-20 animate-pulse rounded bg-muted" />
          <div className="h-4 w-16 animate-pulse rounded bg-muted" />
        </div>
        <div className="flex justify-between">
          <div className="h-4 w-40 animate-pulse rounded bg-secondary" />
          <div className="h-4 w-14 animate-pulse rounded bg-secondary" />
        </div>
        <div className="mt-4 flex justify-between border-t border-border pt-4">
          <div className="h-6 w-20 animate-pulse rounded bg-muted" />
          <div className="h-8 w-24 animate-pulse rounded bg-muted" />
        </div>
      </div>
    </CardSkeleton>
  );
}

export function PayActionSkeleton() {
  return (
    <div className="mt-6 h-14 w-full animate-pulse rounded-xl bg-muted" />
  );
}